import { ApiOptions } from '../../api-options.decorator';
import { DefaultParams } from '../../default-params.model';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseVolume } from './base';

/**
 * @internal
 */
export class ApiVolumeNetwork extends ApiBaseVolume {
  /**
   * get all the grid operator or filter by type
   * @param type Grid operator type, empty if no filter wanter
   */
  @ApiOptions({ channel: 'gridOperator.list' })
  getGridOperators(type?: string) {
    return this.get('/network/grid-operator', new DefaultParams(type ? { type } : {}));
  }

  @ApiOptions({ channel: 'gridOperator.get' })
  getGridOperator(code: string) {
    return this.get(`/network/grid-operator/${code}`);
  }

  @ApiOptions({ interceptErrors: false })
  getGasTransportCharacteristic(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.get(`/network/ngfr/characteristics/${gridOperator}/${meteringPoint}`, params);
  }

  @ApiOptions({ channel: 'logisticPutGasTransportCharacteristic', interceptErrors: false })
  putGasTransportCharacteristic(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.put(`/network/ngfr/characteristics/${gridOperator}/${meteringPoint}`, params);
  }

  /**
   * Get delivery points filtered by deliveryPoint if provided
   */
  @ApiOptions({ channel: 'deliveryPoint.get' })
  getDeliveryPoints(params: ParamsAdapter) {
    return this.get('/network/point', params);
  }

  /**
   * get a list of meter code linked to a particular meter
   */
  @ApiOptions({ channel: 'deliveryPoint.get' })
  getMeterCodesByParent(params: ParamsAdapter) {
    return this.get('/network/point-topology', params);
  }

  @ApiOptions({ channel: 'deliveryPointTopologyPut' })
  putDeliveryPointTopology(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.put(`/network/point-topology/${gridOperator}/${meteringPoint}`, params);
  }

  /**
   * get a list of point type codes
   */
  @ApiOptions({ channel: 'deliveryPoint.getTypes' })
  getPointTypes() {
    return this.get(`/network/point-type`);
  }

  /**
   * get a delivery point by it's code and grid operator
   */
  @ApiOptions({ channel: 'deliveryPoint.get' })
  getDeliveryPoint(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.get(`/network/point/${gridOperator}/${meteringPoint}`, params);
  }

  @ApiOptions({ channel: 'deliveryPoint.patch' })
  putDeliveryPoint(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.put(`/network/point/${gridOperator}/${meteringPoint}`, params);
  }

  @ApiOptions({ channel: 'logisticGetPowerTransportCharacteristic' })
  getPowerTransportCharacteristic(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.get(`/network/pwfr/characteristics/${gridOperator}/${meteringPoint}`, params);
  }

  @ApiOptions({ channel: 'logisticPutPowerTransportCharacteristic', interceptErrors: false })
  putPowerTransportCharacteristic(gridOperator: string, meteringPoint: string, params: ParamsAdapter) {
    return this.put(`/network/pwfr/characteristics/${gridOperator}/${meteringPoint}`, params);
  }

  @ApiOptions({ channel: 'fileExport', responseType: 'blob' })
  getFile(path: string) {
    return this.get<Blob>(`/${path}`);
  }
}
